import { Component } from '@angular/core';
import { BaseModalComponent } from '../../general/base/base-modal-component';

@Component({
  selector: 'app-message-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.css']
})
export class MessageModalComponent extends BaseModalComponent {
  get message(): string {
    return this.data && this.data.message ? this.data.message : '';
  }
}
